export const HOUSEHOLD_PROFILE = "HouseholdProfile";
